<ng-container *ngIf="uiLayout === uiLayoutEnum.NAVIGATION_MENU && showMenu">
  <mat-accordion *ngIf="menuState$ | async as menu">
    <mat-expansion-panel *ngFor="let gruppe of menu.MenuGruppen; index as i;"
                         [expanded]="(menuGruppenIndexObs$ | async)?.Identifikator === gruppe.Identifikator"
                         [disabled]="isDisabled" (click)="gruppeClicked(i)" (closed)="closedMenuGruppe(i)">
      <mat-expansion-panel-header [ngClass]="{'lv-invalid-menu-gruppe': showMenuGruppeInErrorState?.includes(gruppe.Identifikator) &&
                                                                   (currentMenuGruppenIndex !== i || currentMenuGruppenIndex === lastClosedMenuGruppenIndex)}">
        <mat-panel-title>{{i + 1}}. {{gruppe.Titel}}</mat-panel-title>
      </mat-expansion-panel-header>

      <mat-nav-list [disabled]="isDisabled">
        <ng-container *ngFor="let menuSeite of gruppe.MenuSeiten">
          <lv-menu-item [menuSeite]="menuSeite" [uiArtefakt]="uiArtefakt">
          </lv-menu-item>
        </ng-container>
      </mat-nav-list>
    </mat-expansion-panel>
  </mat-accordion>
</ng-container>
